import React, { ReactElement } from 'react';
import { HeadTag } from 'shared/components';
import { Box } from '@mui/material';
import ComplianceList from './components/ComplianceList';
import PageHeader from 'shared/components/PageHeader';

const ComplianceTracking = (): ReactElement => (
  <>
    <PageHeader
      title="Compliance Tracking"
      description="Track evidence collection for your active compliance frameworks"
    />
    <Box className="compliance compliance-tracking">
      <HeadTag title="Compliance Tracking" />

      <Box className="compliance-tracking-wrapper">
        <ComplianceList />
      </Box>
    </Box>
  </>
);

export default ComplianceTracking;
